module.exports = ".items .item-list mat-list-item {\n  word-wrap: break-word;\n  width: auto;\n  height: auto;\n  min-height: 48px;\n}\n.items .item-list mat-list-item .email {\n  min-width: 34%;\n}\n.items .item-list mat-list-item .name {\n  min-width: 22%;\n}\n.items .item-list mat-list-item .role {\n  min-width: 22%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/admin/users/users.component.less
// module id = ./Angular/app/admin/users/users.component.less
// module chunks = main